<template>
  <transition-group tag="div"
                    name="mob-menu"
                    duration="300"
                    class="mob-menu__content">
    <div v-show="typeof openIndex !== 'number'"
         :key="menu.name + 'tt'"
         class="mob-menu__list-wrap">
      <div v-if="menu.name"

           @click.prevent="$emit('back')"
           class="mob-menu__back">
        <BaseSvg name="ico-arrow-light"/>
        {{ menu.name }}
      </div>
      <ul key="main"
          class="mob-menu__list">
        <li v-for="(item, index) in menu.list"
            :key="item.title"
            class="mob-menu__list-item">
          <button v-if="item.subMenu && item.subMenu.list.length"
                  @click.prevent="onOpenSubmenu(index)"
                  class="mob-menu__list-sublist-link">
            <BaseSvg name="ico-arrow-light-2"/>
          </button>

          <a v-if="item.url"
             :href="item.url"
             class="mob-menu__list-link"
             :target="item.target">
            {{ item.title }}
          </a>
          <router-link-modified v-else
                                ref="menuLinks"
                                :disabled="item.disabled"
                                :class="{ _disabled: item.disabled }"
                                :to="item.to"
                                :target="item.target"
                                class="mob-menu__list-link">
            <div v-if="item.ico"
                 :style="`background-image: url('${item.ico}')`"
                 class="mob-menu__list-link-ico"></div>
            {{ item.title }}
          </router-link-modified>

          <span
            v-if="typeof item.badge === 'function' && item.showBadge && item.showBadge()"
            class="account-dropdown__link-badge _mobile mr-2 ml-2"
          >
            {{ item.badge() }}
          </span>
        </li>
      </ul>

      <div class="mob-menu__list-footer">
        <button v-if="menu.footerLogout"
                key="footerLogout"
                @click.prevent="onClickLogout"
                class="mob-menu__list-logout  base-btn  base-btn--outline-dark  base-btn--small">
          <span>{{ $tHeader('Logout') }}</span>
          <BaseSvg name="ico-logout" width="1.5rem" height="1.1rem"/>
          <BasePreloader v-if="pendingLogut"
                         class="_small"/>
        </button>
      </div>
    </div>

    <template v-for="(item, indexSubLists) in menu.list">
      <template v-if="item.subMenu
               && item.subMenu.list.length">
        <MobMenuList v-show="indexSubLists === openIndex"
                     :key="item.title + 'll'"
                     :menu="item.subMenu"
                     @back="openIndex = null"
                     @close="onClose"
                     class="_sub-menu"/>
      </template>
    </template>
  </transition-group>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'MobMenuList',
    props: {
      menu: Object
    },
    data() {
      return {
        openIndex: null,
        pendingLogut: false,
      }
    },
    computed: {
      ...mapGetters('user', [
        'userType',
      ]),
    },
    mounted() {
      this.$refs.menuLinks.forEach(l => l.$el.addEventListener('click', this.onLinkClick));
    },
    beforeDestroy() {
      this.$refs.menuLinks.forEach(l => l.$el.removeEventListener('click', this.onLinkClick));
    },
    methods: {
      onClose() {
        this.$emit('close')
      },
      onClickBack(indexSubLists) {
        console.log(indexSubLists)
      },
      onOpenSubmenu(index) {
        this.openIndex = index
      },
      onClickLogout() {
        if (this.pendingLogut) return
        this.pendingLogut = true

        this.$store.dispatch('user/logoutUser', { userType: this.userType })
          .finally(() => {
            this.pendingLogut = false

            this.onClose();
          })
      },
      onLinkClick($event) {
        if ($event.target.disabled) {
          $event.stopPropagation();
          $event.preventDefault();
        }
      },
    },
  }
</script>

<style lang="less">

</style>
